export const stributor = {
  name: 'stributor',
  path: '/stributor',
  component: () => import('@/views/member/striNew'),
  meta: {
    layout: 'mobile-default',
    text: '총판페이지',
    gnb: false
  }
}
